import { flattenDeep } from 'lodash'

import { ROOT_CATALOG_ID } from 'constants/catalog'

import { CatalogNavigationDto, CatalogPhotoDto } from '../types/dtos/catalog'
import { CatalogNavigationModel } from '../types/models/catalog'

function isCatalogPhotoDto(
  value: Record<string, unknown> | undefined | null,
): value is CatalogPhotoDto {
  return value != null && 'url' in value
}

export const transformCatalogNavigationDto = (
  catalog: CatalogNavigationDto,
): CatalogNavigationModel => {
  const { id, title, code, url, order, experiment } = catalog

  return {
    id,
    title,
    code,
    url,
    order,
    experiment,
    type: catalog.type,
    isHidden: catalog.is_hidden,
    photo: isCatalogPhotoDto(catalog.photo) ? catalog.photo : null,
    customUrl: catalog.custom_url,
    canBrowseSubcategories: catalog.allow_browsing_subcategories ?? false,
    unisexCatalogId: catalog.unisex_catalog_id,
    badge: catalog.badge,
    depth: catalog.depth || 0,
    catalogIds: catalog.catalogs.map(item => item.id),
    catalogs: catalog.catalogs.map(dto => transformCatalogNavigationDto(dto)),
  }
}

export const transformCatalogNavigationDtoList = (
  catalogList: Array<CatalogNavigationDto>,
): Array<CatalogNavigationModel> => {
  return catalogList.map(transformCatalogNavigationDto)
}

const catalogNavigationTree = (
  catalogs: Array<CatalogNavigationDto>,
  depth = 0,
): RecursiveArray<CatalogNavigationDto> =>
  catalogs.map(catalog => {
    const catalogWithDepth = {
      ...catalog,
      depth,
    }

    return [catalogWithDepth, ...catalogNavigationTree(catalog.catalogs, depth + 1)]
  })

const flattenCatalogNavigationDtos = (
  catalogs: Array<CatalogNavigationDto>,
): Array<CatalogNavigationDto> => flattenDeep(catalogNavigationTree(catalogs))

const applyNavigationParentId = (
  catalog: CatalogNavigationModel,
  index: number,
  catalogs: Array<CatalogNavigationModel>,
): CatalogNavigationModel => {
  const parent = catalogs.find(it => it.catalogIds.includes(catalog.id))
  const parentId = parent ? parent.id : ROOT_CATALOG_ID

  return { ...catalog, parentId }
}

export const transformCatalogNavigationDtos = (
  catalogs: Array<CatalogNavigationDto>,
): Array<CatalogNavigationModel> =>
  flattenCatalogNavigationDtos(catalogs)
    .map(transformCatalogNavigationDto)
    .map(applyNavigationParentId)
